export default __webpack_public_path__ + "static/media/A17.51a9dead.png";